import {RequestEntity} from "../../../../types/RequestEntity";
import {Box} from "@mui/material";
import DateViewer from "components/DateViewer";
import React from "react";

// Компонент рендеринга ячейки для даты
export const DateCellRenderer = React.memo(function DateCellRenderer({equipmentRequestEntity}: { equipmentRequestEntity: RequestEntity }) {
    return (
        <Box color={'grey.600'}>
            <DateViewer date={equipmentRequestEntity?.createdAt}/>
        </Box>
    );
}, (prevProps, nextProps) => {
    return (
        prevProps.equipmentRequestEntity.id === nextProps.equipmentRequestEntity.id &&
        prevProps.equipmentRequestEntity.createdAt === nextProps.equipmentRequestEntity.createdAt
    );
});